export default __webpack_public_path__ + "static/Shaping_Tomorrow-9b10cc85d958e87212599ffc8157755d.png";